<template><div></div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'LandingpageLoadPromotionWrapper',
  data () {
    return { }
  },
  created () {
    this.SET_SELECTED_TARIFF(null)
    this.loadDefaultTariff().then(() => {
      this.loadPresalePromotions()
    })
  },
  mixins: [],
  methods: {
    ...mapActions('checkout/tariff', ['loadDefaultTariff']),
    ...mapMutations('promotion', [
      'savePresaleInclusive',
      'savePresaleBookable'
    ]),
    ...mapMutations('checkout/tariff', ['SET_SELECTED_TARIFF']),
    loadPresalePromotions () {
      const prefetchData = window.$gqlpre
      this.savePresaleInclusive({
        prefetchData: prefetchData.inclusiveAvailablePresalesPromotions !== null ? prefetchData.inclusiveAvailablePresalesPromotions : [],
        force: true
      })
      this.savePresaleBookable({
        prefetchData: prefetchData.bookableAvailablePresalesPromotions !== null ? prefetchData.bookableAvailablePresalesPromotions : [],
        force: true
      })
    }
  }
}
</script>
